
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'EC通販業',
      description: '自社ECサイトおよびモール型プラットフォームを活用した通販事業を展開。商品企画から販売・物流・カスタマーサポートまで一貫した体制で、オンライン販売の最大化を実現します。',
      image: 'https://public.readdy.ai/ai/img_res/fd4d46288e88a4680e10ac023c1b9fa3.jpg'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '経営コンサルティング事業',
      description: '経営戦略の策定、ブランド構築、組織づくりなど、企業の持続的な成長をサポートします。実践的な視点での経営支援を行います。',
      image: 'https://readdy.ai/api/search-image?query=Business%20consulting%20meeting%20with%20professionals%20discussing%20strategy%2C%20corporate%20boardroom%20with%20presentation%20charts%2C%20collaborative%20business%20planning%20session&width=400&height=300&seq=consulting&orientation=landscape'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '教育・スクール事業',
      description: '経営者・起業家を対象に、経営・投資・事業に関する専門知識を体系化し、次世代リーダー育成を目的とした教育プログラムを展開しています。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20education%20seminar%20with%20executives%20learning%2C%20modern%20classroom%20setting%20with%20presentation%20screen%2C%20leadership%20development%20training%20session&width=400&height=300&seq=education&orientation=landscape'
    },
    {
      icon: 'ri-truck-line',
      title: '物流・貿易サポート事業',
      description: 'グループ会社および提携企業と連携し、輸入から国内配送までの流通最適化を支援。コスト削減と品質向上を両立するサプライチェーンネットワークを提供します。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20logistics%20warehouse%20with%20organized%20inventory%20and%20shipping%20operations%2C%20supply%20chain%20management%20and%20distribution%20center%2C%20efficient%20cargo%20handling%20systems&width=400&height=300&seq=logistics&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">事業内容</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow border border-blue-100">
              <img 
                src={service.image}
                alt={service.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-blue-900">{service.title}</h3>
                </div>
                <p className="text-blue-700 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
